/**
 * UI elements
 */
class ME_UI {
    constructor() {
        this.initSmoothScroll();
        this.initFooterSwitch();
        this.initPersonToggle();
        this.initTeacherzoneLoginBox();
        this.initInputsEffect();
        this.initTabAccordion();
        this.initTabCategoriesAccordion();
        this.initOpenContentMenuBar();
        this.initOpenContentMenuSelect();
        this.initYTVideoWithCover();
        this.initReadmoreReadless();
        this.initLoadMore();
        this.initOpenExpandableProductContent();
        this.initOpenExpandableProductList();
        this.initOpenMaterialTools();
        this.initPricesShowMore();
        this.initProductPanelLevel();
        this.initCloseNotification();
        this.initLazyLoadImages();
        this.initTabsExmas();
        this.stickyMenu();
        this.closeInfoBox();
        this.initSmoothScrollHash();
        this.checkInfoSS();
        this.scrollTopButton();
        this.scrolllToLogin();
        this.closeInfoSS();
        this.countInput();
        this.showBookList();
        this.resultsCheckValue();

        $(document).on('me-init-input-effect', () => {
            this.initInputsEffect();
        });
    }

    closeInfoSS() {
        function setCookie(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        }

        function addIdToCookies(containerId) {
            const existingIds = getCookie('selectedContainers') || '';
            const ids = existingIds ? existingIds.split(',') : [];

            if (!ids.includes(containerId)) {
                ids.push(containerId);
                setCookie('selectedContainers', ids.join(','), 1);
            }
        }

        function getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return null;
        }

        $('.ssinfo').find('.ssinfo-close-btn').on('click', function (e) {
            e.preventDefault();
            $('.ssinfo').css('display', 'none');
            var containerId = $('.ssinfo').attr('data-id');
            addIdToCookies(containerId)
        })
    }

    scrolllToLogin() {
        $('.scroll-login').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(".exams-section-login").offset().top - 150
            }, 500);
        })
    }

    scrollTopButton() {
        let buttonScroll = document.querySelector('.scroll-to-top');
        if (buttonScroll) {
            buttonScroll.addEventListener('click', (e) => {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            })

            window.addEventListener('scroll', function () {
                let offsetScroll = this.scrollY;
                if (offsetScroll > 500) {
                    buttonScroll.classList.add('show')
                } else {
                    buttonScroll.classList.remove('show')
                }
            })
        }
    }

    checkInfoSS() {
        window.addEventListener('DOMContentLoaded', function (e) {
            var header = document.querySelector('#header');

            if (header.classList.contains('with-info-bar')) {
                document.querySelector('#main').classList.remove('without-ssinfo');
            }
        })
    }

    stickyMenu() {
        window.addEventListener('scroll', function () {
            var header = $('#header').outerHeight();
            var mobileView = window.matchMedia('(max-width: 560px)');
            if (window.scrollY > 220) {
                if (!mobileView.matches) {
                    $('.strefa-user-top.type-matura').addClass('sticky');
                    $('.strefa-user-top.type-matura').css('top', `${header}px`);
                } else {
                    $('.strefa-user-top.type-matura').removeClass('sticky');
                    $('.strefa-user-top.type-matura').removeAttr('style');
                }
            } else {
                $('.strefa-user-top.type-matura').removeClass('sticky');
                $('.strefa-user-top.type-matura').css('top', 'initial');
            }
        });
    }

    closeInfoBox() {
        $('.info-box').find('.close').on('click', function (e) {
            e.preventDefault()
            $('.info-box').removeClass('active')
        })
    }

    initSmoothScroll() {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 170
                    }, 1000);
                }
            }
        });
    }

    initSmoothScrollHash() {
        window.addEventListener('DOMContentLoaded', function () {
            var target = window.location.hash;
            if (target !== '') {
                $('html, body').animate({
                    scrollTop: $(`${target}`).offset().top - 70
                }, 1000);
            }
        })
    }

    initFooterSwitch() {
        let footerMenu = $('.footer-menu');
        let footerMenuItem = footerMenu.find('.footer-menu-item');

        if (!footerMenuItem.length) {
            return
        }

        let footerMenuAccordion = footerMenuItem.find('h2');

        footerMenuAccordion.on('click', function () {
            $(this).parent().toggleClass('active');
        });
    }

    initPersonToggle() {
        let representativesSingle = $('.representatives-single');
        let personToggle = representativesSingle.find('.person-toggle');
        let columnForm = representativesSingle.find('.form');

        if (!personToggle.length) {
            return
        }

        let personToggleMore = $('.person-toggle__more');

        if (personToggle.outerHeight() > columnForm.outerHeight()) {
            $('.person-wrapper').addClass('active')
        } else {
            personToggleMore.on('click', function (e) {
                e.preventDefault()
                $(this).closest('.person-toggle').addClass('active');
            });
        }
    }

    initTeacherzoneLoginBox() {
        let teacherzoneLoginBox = $('.teacherzone-login .login-box');
        let teacherzoneLoginWrapper = jQuery('.teacherzone-login .wrapper');
        let teacherzoneCircle = $('section.teacherzone-offer .circle');

        if (!teacherzoneLoginBox.length) {
            return
        }

        $(window).on('scroll', function () {
            if ($(window).width() > 760 && teacherzoneCircle.length) {
                let top = $(window).scrollTop();
                let pos = (top - teacherzoneCircle.offset().top) + (teacherzoneCircle.offset().top - teacherzoneLoginWrapper.offset().top) + 60;
                if (top > teacherzoneLoginWrapper.offset().top - 60) {
                    teacherzoneLoginBox.css('top', (teacherzoneCircle.offset().top - 120 - top > 0 ? pos : teacherzoneCircle.offset().top - teacherzoneLoginWrapper.offset().top - 60) + 'px');
                }
                else {
                    teacherzoneLoginBox.css('top', '0');
                }
            }
            else {
                teacherzoneLoginBox.css('top', '0');
            }
        }).scroll();
    }

    initInputsEffect() {
        let inputsWithEffect = $('.effect .input');

        for (let i = 0; i < inputsWithEffect.length; i++) {
            let input = inputsWithEffect.eq(i);

            if (input.data('focus-effect-initialized')) {
                continue;
            }

            if (input.val() !== '') {
                input.addClass('focus');
            }

            input.on('focus', function () {
                $(this).addClass('focus');
            });

            input.on('blur', function () {
                if (this.value === '') {
                    $(this).removeClass('focus');
                }
            });

            input.data('focus-effect-initialized', true);
        }
    }

    initTabAccordion() {
        let tabListAccordion = $('ul.accordion');

        if (!tabListAccordion.length) {
            return
        }

        let tabListAccordionItem = tabListAccordion.find('.accordion-item');

        tabListAccordionItem.find('.header').on('click', function () {
            $(this).closest('.accordion-item').toggleClass('active');
        });
    }

    initTabCategoriesAccordion() {
        let tabAccordion = $('.tabs-accordion');

        if (!tabAccordion.length) {
            return
        }

        tabAccordion.each(function () {
            var spis = $(this);

            if (spis.find('.categories > li.active').length < 1) {
                spis.find('.categories > li').eq(0).addClass('active');
                spis.find('.articles > li').eq(0).addClass('active');
            }

            spis.find('.categories > li a').on('click', function (e) {
                e.preventDefault();

                var index = $(this).closest('li').index('.categories > li');

                spis.find('.categories > li').removeClass('active');
                spis.find('.categories > li').eq(index).addClass('active');

                spis.find('.articles > li').removeClass('active');
                spis.find('.articles > li').eq(index).addClass('active');
            });
        });
    }

    initOpenContentMenuBar() {
        let contentMenuBar = $('.content-menu-bar');

        if (!contentMenuBar.length) {
            return
        }

        let openContentMenuBar = contentMenuBar.find('.current-tab');
        let contentMenuBarList = contentMenuBar.find('ul');
        let contentMenuBarItem = contentMenuBar.find('li a');

        openContentMenuBar.on('click', function () {
            contentMenuBarList.toggleClass('active');
        });

        for (let i = 0; i < contentMenuBarItem.length; i++) {
            contentMenuBarItem.eq(i).on('click', () => {
                contentMenuBarList.removeClass('active');
            });
        }
    }

    initOpenContentMenuSelect() {
        let contentMenuSelect = $('.content-menu-select');

        if (!contentMenuSelect.length) {
            return
        }

        let opencontentMenuSelect = contentMenuSelect.find('.current-tab');
        let contentMenuSelectList = contentMenuSelect.find('ul');
        let contentMenuSelectItem = contentMenuSelect.find('li a');

        opencontentMenuSelect.on('click', function () {
            contentMenuSelectList.toggleClass('active');
        });

        for (let i = 0; i < contentMenuSelectItem.length; i++) {
            contentMenuSelectItem.eq(i).on('click', () => {
                contentMenuSelectList.removeClass('active');
                let currentMenuItemText = contentMenuSelectItem.eq(i).text();
                opencontentMenuSelect.text(currentMenuItemText);
            });
        }
    }

    initYTVideoWithCover() {
        let videos = $('.default-video-wrapper .cover');

        if (!videos.length) {
            return;
        }

        for (let i = 0; i < videos.length; i++) {
            let cover = videos.eq(i);

            videos.eq(i).on('click', e => {
                e.preventDefault();
                cover.addClass('is-hidden');
                let iframe = cover.parent().find('iframe');

                iframe.on('load', function () {
                    setTimeout(() => {
                        iframe[0].contentWindow.postMessage(JSON.stringify({
                            'event': 'command',
                            'func': 'playVideo',
                            'args': []
                        }), '*');
                    }, 500);
                });

                iframe.attr('src', iframe.attr('data-src'));
            });
        }
    }

    initReadmoreReadless() {
        let btnShowMore = $('.btn-show-more');

        if (!btnShowMore.length) {
            return;
        }

        for (let i = 0; i < btnShowMore.length; i++) {
            btnShowMore.eq(i).on('click', e => {
                e.preventDefault();
                let clickedBtnShowMore = $(e.target);

                if (clickedBtnShowMore.hasClass('active')) {
                    clickedBtnShowMore.removeClass('active');
                    clickedBtnShowMore.parent().find('.full-text').removeClass('active');
                } else {
                    clickedBtnShowMore.addClass('active');
                    clickedBtnShowMore.parent().find('.full-text').addClass('active');
                }
            });
        }
    }

    initLoadMore() {
        let loadMoreLink = $('.view-more');

        if (!loadMoreLink.length) {
            return;
        }

        loadMoreLink.on('click', (e) => {
            e.preventDefault();
            $(e.target).addClass('active');
        })
    }

    initOpenExpandableProductContent() {
        let btnExpandalbe = $('.product-content-sections-wrapper__button');
        let productContentExpandable = $('.product-content-sections-wrapper--expandable');

        if (!btnExpandalbe.length) {
            return;
        }

        btnExpandalbe.on('click', e => {
            e.preventDefault()
            productContentExpandable.addClass('active');
            $(this).closest('#main').find('.hide-description-section').removeClass('hidden');
            $(this).remove()
        })
    }

    initOpenExpandableProductList() {
        let btnExpandableList = $('.product-default__show-more');

        if (!btnExpandableList.length) {
            return;
        }

        btnExpandableList.on('click', (e) => {
            e.preventDefault();
            $(e.target).parents('.product-default-component__content').find('.product-expandable-list').addClass('active');
            $(e.target).remove();
        })
    }

    initOpenMaterialTools() {
        let btnOpenMaterialTools = $('.product-material-tools__table__show-more-trigger');

        if (!btnOpenMaterialTools.length) {
            return;
        }

        btnOpenMaterialTools.on('click', (e) => {
            e.preventDefault();
            $(e.target).prev('.product-material-tools__table').addClass('active');
            $(e.target).remove();
        });
    }

    initPricesShowMore() {
        let btnPricesShowMore = $('.product-prices__show-more');

        if (!btnPricesShowMore.length) {
            return;
        }

        btnPricesShowMore.on('click', (e) => {
            e.preventDefault();
            $('.product-prices').addClass('active');
            $(e.target).remove();
        })
    }

    initProductPanelLevel() {
        $('ul.product-panel__levels li').click((e) => {
            var level_index = $(e.target).data('level');

            $('ul.product-panel__levels li').removeClass('active');
            $('ul.product-panel__levels li[data-level="' + level_index + '"]').addClass('active');

            $('.level-p').addClass('hidden');
            $('.level-p.level-p-' + level_index).removeClass('hidden');

            $('.row_level').addClass('hidden');
            $('.row_level_' + (level_index)).removeClass('hidden');

        });
    }

    initCloseNotification() {
        let notificationBar = $('.teacherzone-notification');

        if (!notificationBar.length) {
            return;
        }

        let closeNotificationBar = notificationBar.find('.close');

        closeNotificationBar.on('click', (e) => {
            e.preventDefault();
            closeNotificationBar.parents('.teacherzone-notification').addClass('hidden');
        });
    }

    // initTextAccordion () {
    //   if ($(document.body).hasClass('js-ui-accordion-initialized')) {
    //     return;
    //   }

    //   $(document.body).addClass('js-ui-accordion-initialized');

    //   $(".js-accordion").each(function(i, item) {
    //     $(item).find('.js-accordion-content').css('height', 0);

    //     $(item).on("click", function () {
    //       let item = $(this);
    //       let contentWrapper = item.find('.js-accordion-content');
    //       let contentText = item.find('.js-accordion-content > div');

    //       item.toggleClass('active');
    //       let newHeight = contentText.outerHeight();

    //       if (item.hasClass('active')) {
    //         contentWrapper.css('height', 0);

    //         setTimeout(function() {
    //           contentWrapper.css('height', newHeight + 'px');
    //         }, 0);

    //         setTimeout(function() {
    //           contentWrapper.css('height', 'auto');
    //         }, 500);
    //       } else {
    //         contentWrapper.css('height', newHeight + 'px');

    //         setTimeout(function() {
    //           contentWrapper.css('height', 0);
    //         }, 0);
    //       }
    //     });
    //   });
    // }

    initLazyLoadImages() {
        $(window).on('load', function () {
            $('img.lazy').each(function () {
                $(this).attr('src', $(this).attr('lazy-src'));
                $(this).addClass('lazy-loaded')
            });
            $('.lazy-bg').each(function () {
                $(this).attr('style', $(this).data('bg'));
                $(this).addClass('lazy-loaded')
            });
        });
    }

    initTabsExmas() {
        let tabs = $('.tabs');

        if (!tabs.length) {
            return;
        }

        $('.tabs .tabs-navigation li').first().addClass('active');
        $('.tabs .tabs-contents .tab').first().addClass('active');

        $('.tabs-navigation .tab').on('click', function () {
            var index = $(this).index();
            var container = $(this).closest('.tabs');

            container.find('.tabs-navigation li').removeClass('active');
            container.find('.tabs-navigation li').eq(index).addClass('active');

            container.find('.tabs-contents .tab').removeClass('active');
            container.find('.tabs-contents .tab').eq(index).addClass('active');
        });
    }

    countInput() {
        let countInput = document.querySelectorAll('.count-input');
        if (countInput.length > 0) {
            for (let i = 0; i < countInput.length; i++) {
                let btnPlus = countInput[i].querySelector('.count-plus');
                let btnMinus = countInput[i].querySelector('.count-minus');
                let changeInput = countInput[i].querySelector('input[type="number"]');

                btnPlus.addEventListener('click', function (e) {
                    e.preventDefault();
                    changeInput.value = Number(changeInput.value) + Number(1);
                    changeInput.dispatchEvent(new Event('input', { bubbles: true }));
                    changeInput.dispatchEvent(new Event('change', { bubbles: true }));
                })

                btnMinus.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (changeInput.value <= 0) {
                        return
                    } else {
                        changeInput.value = Number(changeInput.value) - Number(1);
                        changeInput.dispatchEvent(new Event('input', { bubbles: true }));
                        changeInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                })
            }
        }
    }

    showBookList() {
        let declarationForm = document.querySelectorAll('.declaration-form');
        if (declarationForm.length > 0) {
            for (let f = 0; f < declarationForm.length; f++) {
                let booksElement = declarationForm[f].querySelector('.choose-books-list');
                let booksForm = declarationForm[f].querySelector('.books');
                let booksTable = booksForm.querySelector('.table');
                let bookItem = booksTable.querySelectorAll('.declaration-order');
                let href;
                if (booksElement) {
                    booksElement.querySelector('.activator').addEventListener('click', function (e) {
                        booksElement.classList.toggle('show');
                    })

                    let booksList = booksElement.querySelector('ul');
                    let booksButton = booksList.querySelectorAll('.book-button');

                    if (booksButton.length > 0) {
                        for (let b = 0; b < booksButton.length; b++) {
                            booksButton[b].addEventListener('click', function (e) {
                                e.preventDefault();
                                booksElement.classList.remove('show');
                                href = booksButton[b].getAttribute('data-book-button-id');

                                booksTable.classList.add('show');
                                booksTable.querySelector(`.declaration-order[data-book-id="${href}"]`).classList.add('show');
                            })
                        }
                    }
                }

                if (bookItem.length > 0) {
                    for (let r = 0; r < bookItem.length; r++) {
                        let removeButton = bookItem[r].querySelector('.remove-book');
                        let bookValue = bookItem[r].querySelector('input[type="number"]');
                        removeButton.addEventListener('click', function (e) {
                            e.preventDefault();
                            removeButton.closest('.declaration-order').classList.remove('show');
                            bookValue.value = 0;

                            if (document.querySelectorAll(`.declaration-order.show`).length <= 0) {
                                booksTable.classList.remove('show');
                            }
                        })
                    }
                }
            }
        }
    }

    resultsCheckValue() {
        let resultInput = document.querySelectorAll('.results-input');
        if (resultInput.length > 0) {
            for (let i = 0; i < resultInput.length; i++) {
                if (Number(resultInput[i].value) === 0) {
                    resultInput[i].removeAttribute('value');
                    resultInput[i].setAttribute('placeholder', '0');
                }

                resultInput[i].addEventListener('focus', function (e) {
                    if (Number(resultInput[i].value) === 0) {
                        resultInput[i].removeAttribute('placeholder');
                    }
                })

                resultInput[i].addEventListener('focusout', function (e) {
                    if (Number(resultInput[i].value) === 0) {
                        resultInput[i].setAttribute('placeholder', '0');
                    }
                })
            }
        }
    }
}
